import React, { Component } from "react";
import Proptypes from "prop-types";
import { connect } from "react-redux";
import { Form, FormGroup, Button, Label, Row, Col, CardBody, CardFooter } from "reactstrap";
import {
    renderField,
    required,
    renderPass
} from "../../../../utils/formValidations.js";
import { Field, reduxForm, formValueSelector } from "redux-form";
import { withRouter } from "react-router-dom";

class AwsDnsProviderFormTemplate extends Component {

    constructor(props) {
        super(props);
        this.state = {
            currentProvider: {},
        };
        this.submitApi = this.submitApi.bind(this);
        this.cancelButton = this.cancelButton.bind(this);
    }

    componentDidMount() {
        if (this.props.current_provider) {
            this.props.initialize({
                dns_provider_config_name: this.props.current_provider.dns_provider_config_name,
                dns_provider_name: this.props.current_provider.dns_provider_name,
                aws_access_key_id: this.props.current_provider.aws_access_key_id,
                aws_secret_access_key: this.props.current_provider.aws_secret_access_key,
            });
        }
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        if (nextProps.current_provider && this.props.current_provider !== nextProps.current_provider) {
            this.props.initialize({
                dns_provider_config_name: nextProps.current_provider.dns_provider_config_name,
                dns_provider_name: nextProps.current_provider.dns_provider_name,
                aws_access_key_id: nextProps.current_provider.aws_access_key_id,
                aws_secret_access_key: nextProps.current_provider.aws_secret_access_key,
            });
        }
    }


    cancelButton() {
        this.props.cancel_button(userData)
    }

    submitApi(userData) {
        userData.dns_provider_name = "aws"
        this.props.submit_api(userData)

    }

    render() {
        const { handleSubmit } = this.props;

        return (
            <Form onSubmit={handleSubmit(this.submitApi)}>
                <CardBody>
                    <FormGroup>
                        <Row>
                            <Col>
                                <Label htmlFor="dns_provider_config_name" className="requiredasterisk">Name </Label>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <Field type="text"
                                    name="dns_provider_config_name"
                                    id="dns_provider_config_name"
                                    component={renderField}
                                    validate={required}
                                    placeholder="Example Aws Config"
                                />
                            </Col>
                        </Row>
                    </FormGroup>
                    <FormGroup>
                        <Row>
                            <Col>
                                <Label htmlFor="aws_access_key_id" className="requiredasterisk">Access Key ID</Label>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <Field type="text"
                                    name="aws_access_key_id"
                                    id="aws_access_key_id"
                                    component={renderField}
                                    validate={required}
                                    placeholder="00000000-0000-0000-0000-000000000000"
                                />
                            </Col>
                        </Row>
                    </FormGroup>
                    <FormGroup>
                        <Row>
                            <Col>
                                <Label htmlFor="aws_secret_access_key" className="requiredasterisk">Access Key Secret</Label>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <Field type="password"
                                    name="aws_secret_access_key"
                                    id="aws_secret_access_key"
                                    component={renderPass}
                                    validate={required}
                                />
                            </Col>
                        </Row>
                    </FormGroup>
                </CardBody>
                <CardFooter>
                    <FormGroup className="form-actions">
                        <Button type="button" size="sm"
                            className="cancel-button"
                            color="basic" onClick={() => this.props.cancel_button()}>{ this.props.wizard ? 'Previous' : 'Cancel'}</Button>
                        <Button type="submit"
                            className="submit-button"
                            size="sm" color="primary">{ this.props.wizard ? 'Finish' : 'Submit'}</Button>
                    </FormGroup>
                </CardFooter>
            </Form>
        );
    }
}


AwsDnsProviderFormTemplate.propTypes = {
    current_provider: Proptypes.object,
    submit_api: Proptypes.func.isRequired,
    handleSubmit: Proptypes.func,
    cancel_button: Proptypes.func,
};


let AwsDnsProviderFormWithRouter = withRouter(AwsDnsProviderFormTemplate);


const selector = formValueSelector('AwsDnsProviderForm');

let AwsDnsProviderForm = connect(state => {

    return {
        dns_provider_configs: state.dns_provider.dns_provider_configs,
    }
},

    dispatch =>
    ({

    }))(AwsDnsProviderFormWithRouter);

export default reduxForm({
    form: "DnsProviderForm",
})(AwsDnsProviderForm);
